<template>
     <div>
          <snow v-if="isWinter"/>
     </div>
</template>

<script lang="ts">
import snow from '@/components/ui/snow.vue'
import {computed, defineComponent} from "vue";

export default defineComponent({
     components: {
          snow
     },
    setup(){
         const currentMonth = computed(() => new Date(Date.now()).getMonth())
         const isWinter = computed<boolean>(() =>
             currentMonth.value === 0 ||
             currentMonth.value === 1 ||
             currentMonth.value === 11
         )

         return {
              currentMonth,
              isWinter
         }
    }
})


</script>

<style scoped>

</style>